import { render } from "./Index.vue?vue&type=template&id=976b261e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Customers/Matches/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "976b261e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('976b261e', __exports__)) {
    api.reload('976b261e', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=976b261e", () => {
    api.rerender('976b261e', render)
  })

}


export default __exports__